import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { FeatureFlagService } from '@app/shared/services/feature-flag.service';
import { TAXI_OFFICE_KEYS } from '@app/core/i18n/keys/taxi-office.keys';
import { TRANSIT_KEYS } from '@app/core/i18n/keys/transit.keys';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  readonly taxiKeys = TAXI_OFFICE_KEYS;
  readonly transitKeys = TRANSIT_KEYS;
  /** Bus operator sidebar, in the order the office works through the day. */
  readonly transitNav = [
    { path: '/transit/dashboard', label: TRANSIT_KEYS.nav.dashboard, icon: 'overview' },
    { path: '/transit/vehicles', label: TRANSIT_KEYS.nav.vehicles, icon: 'bus' },
    { path: '/transit/map', label: TRANSIT_KEYS.nav.map, icon: 'map' },
    { path: '/transit/drivers', label: TRANSIT_KEYS.nav.drivers, icon: 'drivers' },
    { path: '/transit/routes', label: TRANSIT_KEYS.nav.routes, icon: 'route' },
    { path: '/transit/shifts', label: TRANSIT_KEYS.nav.shifts, icon: 'shift' },
    { path: '/transit/cash', label: TRANSIT_KEYS.nav.cash, icon: 'cash' },
    { path: '/transit/fares', label: TRANSIT_KEYS.nav.fares, icon: 'list' },
    { path: '/transit/reports', label: TRANSIT_KEYS.nav.reports, icon: 'report' },
    { path: '/transit/integrations', label: TRANSIT_KEYS.nav.integrations, icon: 'plug' },
    { path: '/transit/wallet', label: TRANSIT_KEYS.nav.wallet, icon: 'settlements' },
    { path: '/transit/settings', label: TRANSIT_KEYS.nav.settings, icon: 'settings' },
  ] as const;
  isEcommerceOpen = false;
  isVoucherOpen = false;
  currentUrl: string | undefined;
  voucherSectionEnabled$: Observable<boolean>;
  ecommerceSectionEnabled$: Observable<boolean>;
  @Input() isOpen = false;

  constructor(
    public router: Router,
    public auth: AuthService,
    public featureFlagService: FeatureFlagService
  ) {
    this.voucherSectionEnabled$ = combineLatest([
      this.featureFlagService.isFeatureEnabled$('store_vouchers'),
      this.featureFlagService.isFeatureEnabled$('store_vouchers_orders'),
      this.featureFlagService.isFeatureEnabled$('store_voucher_offer')
    ]).pipe(map(([vouchers, orders, bonus]) => vouchers || orders || bonus));
    this.ecommerceSectionEnabled$ = combineLatest([
      this.featureFlagService.isFeatureEnabled$('store_product'),
      this.featureFlagService.isFeatureEnabled$('store_categories'),
      this.featureFlagService.isFeatureEnabled$('store_orders')
    ]).pipe(map(([product, categories, orders]) => product || categories || orders));
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  ngOnInit(): void {
    if (this.auth.getToken() && this.auth.isStoreSession()) {
      this.featureFlagService.fetchFeatures().subscribe();
    }
  }
  public logout() {
    this.featureFlagService.clearCache();
    this.auth.logout().subscribe();
  }

  public toggleEcommerceSection() {
    this.isEcommerceOpen = !this.isEcommerceOpen;
  }
  public toggleVoucherSection() {
    this.isVoucherOpen = !this.isVoucherOpen;
  }
}
